import { Helmet } from "react-helmet-async";

const SITE = "Mount Moriah Relief";
const ORIGIN = "https://mountmoriahrelief.org";

export default function Seo({ title, description, path = "/", type = "website" }) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Bringing Hope. Relieving Hardship. Restoring Dignity.`;
  const canonical = `${ORIGIN}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
    </Helmet>
  );
}
